// extracted by mini-css-extract-plugin
module.exports = {"container":"EbsInformer_container__2r1HH","content":"EbsInformer_content__13rey","imageContainer":"EbsInformer_imageContainer__3Lcae"};